import { memo, Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

const MobileLayout = lazy(() => import('@/components/mobile/MobileLayout').then(module => ({ default: module.MobileLayout })));

export const MobileRouter = memo(() => {
  return (
    <Suspense fallback={
      <LoadingSpinner 
        message="Loading mobile interface..." 
        theme="dark" 
        size="lg" 
        fullScreen={true}
      />
    }>
      <MobileLayout />
    </Suspense>
  );
});

MobileRouter.displayName = 'MobileRouter';